module.exports = __webpack_public_path__ + "img/saucepan-desktop.e7998596.png";